import { Feather } from "@expo/vector-icons";
import React, { useEffect, useRef, useState } from "react";
import { Else, If, Then, When } from "react-if";
import { Dimensions, StyleSheet, Text, View } from "react-native";
import {
  CodeField,
  Cursor,
  useClearByFocusCell,
} from "react-native-confirmation-code-field";

export default function AuthCodeInput({
  label,
  onValueChange,
  cellCount,
  value: v,
  isPassword = false,
  error,
  focus = true,
}) {
  const input = useRef();
  const [value, setValue] = useState(v);
  const [enableMask, setEnableMask] = useState(true);
  const toggleMask = () => setEnableMask((f) => !f);
  const [props, getCellOnLayoutHandler] = useClearByFocusCell({
    value,
    setValue,
  });

  useEffect(() => {
    setValue(v);
    if (focus) {
      input.current.focus();
    }
  }, [v, focus]);

  const renderCell = ({ index, symbol, isFocused }) => {
    let textChild = null;

    if (symbol) {
      textChild = isPassword && enableMask ? "•" : symbol;
    } else if (isFocused) {
      textChild = <Cursor />;
    }

    return (
      <Text
        key={index}
        style={[styles.cell, isFocused && styles.focusCell]}
        onLayout={getCellOnLayoutHandler(index)}
      >
        {textChild}
      </Text>
    );
  };

  return (
    <>
      <Text style={styles.label}>{label}</Text>
      <View style={{ flexDirection: "row", alignItems: "center" }}>
        <CodeField
          {...props}
          ref={input}
          value={value}
          autoFocus={focus}
          onChangeText={(val) => {
            const numericValue = val.replace(/[^0-9]/g, "");
            setValue(numericValue);
            onValueChange(numericValue);
          }}
          cellCount={cellCount}
          rootStyle={styles.codeFieldRoot}
          keyboardType="numeric"
          textContentType="oneTimeCode"
          renderCell={renderCell}
        />
        <When condition={isPassword}>
          <Text style={styles.toggle} onPress={toggleMask}>
            <If condition={enableMask}>
              <Then>
                <Feather name="eye-off" size={18} color="#222" />
              </Then>
              <Else>
                <Feather name="eye" size={18} color="#222" />
              </Else>
            </If>
          </Text>
        </When>
      </View>
      <When condition={error}>
        <Text style={styles.error}>{error}</Text>
      </When>
    </>
  );
}

const window_width = Dimensions.get("screen").width;

const styles = StyleSheet.create({
  label: {
    fontSize: 12,
    marginBottom: 20,
  },
  input: {
    width: "100%",
    borderBottomWidth: 0.5,
  },
  error: {
    marginTop: 15,
    color: "red",
  },
  codeFieldRoot: {
    flex: 1,
    justifyContent: "flex-start",
  },
  cell: {
    width: Math.min(40, Math.ceil(window_width * 0.1)),
    height: Math.min(50, Math.ceil(window_width * 0.12)),
    marginRight: 6,
    borderRadius: 8,
    fontSize: window_width < 360 ? 20 : 24,
    lineHeight: Math.min(50, Math.ceil(window_width * 0.12)),
    borderWidth: 2,
    borderColor: "#00000030",
    textAlign: "center",
  },
  focusCell: {
    borderColor: "#2797A2",
  },
  toggle: {
    padding: 15,
  },
});
